import { useDispatch, useSelector } from 'react-redux';
import omitBy from 'lodash/omitBy';
import { resetAllFieldsValues } from '../store/reducers/form-fields/form-fields.reducer';
import formFieldsSelectors from '../store/selectors/form-fields.selectors';
import { FormFieldsData, ReasonFieldData } from '../types/form.types';

interface useFieldsReturnType {
  resetAllValues: () => void;
  noAttachmentFields: FormFieldsData;
  allFields: FormFieldsData;
  errorMessage?: string;
  isLoading: boolean;
  case_reason?: ReasonFieldData;
  case_detailed_reason?: ReasonFieldData;
}
const useFields = (): useFieldsReturnType => {
  const dispatch = useDispatch();

  const errorMessage = useSelector(formFieldsSelectors.getErrorMessage);
  const allFields = useSelector(formFieldsSelectors.getAllFields);
  const noAttachmentFields = omitBy(
    allFields,
    (val, key) => key === 'attachment'
  );
  const isLoading = useSelector(formFieldsSelectors.getAreFieldsLoading);
  const { case_reason, case_detailed_reason } = useSelector(
    formFieldsSelectors.getReasons
  );

  const resetAllValues = (): void => {
    dispatch(resetAllFieldsValues());
  };

  return {
    resetAllValues,
    allFields,
    noAttachmentFields,
    errorMessage,
    isLoading,
    case_reason,
    case_detailed_reason
  };
};

export default useFields;
